import { Injectable } from '@angular/core'
import { Subject } from "rxjs/Subject";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmarEliminacion } from './ConfirmarEliminacion';


@Injectable()
export class ConfirmarEliminacionService{


	private confirmarEliminacion = new Subject<void>();
	public  eventoFin$ = this.confirmarEliminacion.asObservable();


	constructor(private dialog: MatDialog){
		
	}


	public abrirDialog(infoTemp:any, rutaTemp:string){
		let dialogRef = this.dialog.open(ConfirmarEliminacion, {
			width: '250px',
			data: { info : infoTemp,
				ruta : rutaTemp
			}
		});
		dialogRef.afterClosed().subscribe( result => {
			if(result == true)
				this.confirmarEliminacion.next();
		});	
	}


}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Dialog/ConfirmarEliminacionService.ts